export enum OtpErrorCode {
    // Input Validation Errors (400 Bad Request)
    INVALID_REQUEST = 'INVALID_REQUEST',
    INVALID_EMAIL_PATTERN = 'INVALID_EMAIL_PATTERN',
    INCORRECT_EMAIL = 'INCORRECT_EMAIL',
    INCORRECT_MOBILE = 'INCORRECT_MOBILE',
    MOBILE_TOO_LONG = 'MOBILE_TOO_LONG',
    EMPTY_OR_NULL_MOBILE_NUMBER = 'EMPTY_OR_NULL_MOBILE_NUMBER',
    INCORRECT_COUNTRY_CODE = 'INCORRECT_COUNTRY_CODE',
    EMPTY_OR_NULL_COUNTRY_CODE = 'EMPTY_OR_NULL_COUNTRY_CODE',
    BAD_REQUEST_INVALID_SIGNIN_BODY = 'BAD_REQUEST_INVALID_SIGNIN_BODY',
    BAD_REQUEST_INVALID_SIGNUP_MERGE_BODY = 'BAD_REQUEST_INVALID_SIGNUP_MERGE_BODY',
    BAD_REQUEST_INVALID_UPDATE_MOBILE_BODY = 'BAD_REQUEST_INVALID_UPDATE_MOBILE_BODY',
    BAD_REQUEST_INVALID_UPDATE_EMAIL_BODY = 'BAD_REQUEST_INVALID_UPDATE_EMAIL_BODY',
    BAD_REQUEST_INVALID_DELETE_ACCOUNT_BODY = 'BAD_REQUEST_INVALID_DELETE_ACCOUNT_BODY',
    BAD_REQUEST_INVALID_WHATSAPP_VERIFICATION_BODY = 'BAD_REQUEST_INVALID_WHATSAPP_VERIFICATION_BODY',

    // Authentication & Authorization Errors (401 Unauthorized)
    INVALID_OTP = 'INVALID_OTP',
    OTP_VALIDATE_LIMIT_EXCEEDED = 'OTP_VALIDATE_LIMIT_EXCEEDED',
    NO_SAVED_OTP_FOUND = 'NO_SAVED_OTP_FOUND',
    OTP_SEND_LIMIT_EXCEEDED = 'OTP_SEND_LIMIT_EXCEEDED',
    INVALID_COOKIE_PASSED = 'INVALID_COOKIE_PASSED',
    COOKIE_NOT_FOUND = 'COOKIE_NOT_FOUND',
    INVALID_AUTH_COOKIE = 'INVALID_AUTH_COOKIE',
    SESSION_VALIDATION_FAILED = 'SESSION_VALIDATION_FAILED',

    // Business Logic Errors (403 Forbidden)
    USER_ALREADY_EXISTS_FOR_MOBILE = 'USER_ALREADY_EXISTS_FOR_MOBILE',
    USER_ALREADY_EXISTS_FOR_EMAIL = 'USER_ALREADY_EXISTS_FOR_EMAIL',
    EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE = 'EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE',
    EMAIL_ALREADY_VERIFIED = 'EMAIL_ALREADY_VERIFIED',
    MOBILE_ALREADY_VERIFIED = 'MOBILE_ALREADY_VERIFIED',
    MOBILE_NOT_FOUND_FOR_SIGNED_IN_USER = 'MOBILE_NOT_FOUND_FOR_SIGNED_IN_USER',
    EMAIL_NOT_FOUND_FOR_SIGNED_IN_USER = 'EMAIL_NOT_FOUND_FOR_SIGNED_IN_USER',
    ACCOUNT_MERGE_LIMIT_EXCEEDED = 'ACCOUNT_MERGE_LIMIT_EXCEEDED',
    CROSS_DOMAIN_MERGE_NOT_ALLOWED = 'CROSS_DOMAIN_MERGE_NOT_ALLOWED',
    NOT_B2C_USER = 'NOT_B2C_USER',
    UPDATE_IS_PROHIBITED = 'UPDATE_IS_PROHIBITED',
    FEATURE_IS_CURRENTLY_DISABLED = 'FEATURE_IS_CURRENTLY_DISABLED',

    // Resource Not Found Errors (404 Not Found)
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    SIGNED_IN_USER_NOT_FOUND = 'SIGNED_IN_USER_NOT_FOUND',
    EMAIL_BASED_USER_NOT_FOUND = 'EMAIL_BASED_USER_NOT_FOUND',
    LINKED_COMPANY_NOT_FOUND = 'LINKED_COMPANY_NOT_FOUND',

    // Domain & Service Errors
    DOMAIN_NOT_SUPPORTED = 'DOMAIN_NOT_SUPPORTED',

    // Server Errors (500 Internal Server Error)
    ERROR_IN_SENDING_SMS = 'ERROR_IN_SENDING_SMS',
    ERROR_IN_SENDING_EMAIL = 'ERROR_IN_SENDING_EMAIL',
    ERROR_IN_SENDING_WHATSAPP_OTP = 'ERROR_IN_SENDING_WHATSAPP_OTP',
    SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG'
}

export enum UITreatment {
    INLINE_VALIDATION = 'inline_validation',
    HIGHLIGHT_FIELD = 'highlight_field',
    SHAKE_ANIMATION = 'shake_animation',
    GENERAL_MODAL_ERROR = 'general_modal_error',
    SUCCESS_STATE = 'success_state',
    CONTACT_SUPPORT = 'contact_support',
    RETRY_OPTION = 'retry_option',
    ALTERNATIVE_OPTIONS = 'alternative_options',
    REFRESH_PAGE = 'refresh_page',
    SHOW_SIGNIN_OPTION = 'show_signin_option',
    SHOW_SIGNUP_OPTION = 'show_signup_option',
    SHOW_RESEND_BUTTON = 'show_resend_button',
    DISABLE_SEND_BUTTON = 'disable_send_button'
}

export interface ErrorMapping {
    message: string
    uiTreatment: UITreatment
    field?: 'email' | 'mobile' | 'countryCode' | 'otp'
}

// Mapping from error codes to translation keys (under otpModal.errors.*)
export const ERROR_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
    [OtpErrorCode.INVALID_REQUEST]: 'errors.invalidRequest',
    [OtpErrorCode.INVALID_EMAIL_PATTERN]: 'errors.invalidEmailPattern',
    [OtpErrorCode.INCORRECT_EMAIL]: 'errors.incorrectEmail',
    [OtpErrorCode.INCORRECT_MOBILE]: 'errors.incorrectMobile',
    [OtpErrorCode.MOBILE_TOO_LONG]: 'errors.mobileTooLong',
    [OtpErrorCode.EMPTY_OR_NULL_MOBILE_NUMBER]: 'errors.emptyOrNullMobileNumber',
    [OtpErrorCode.INCORRECT_COUNTRY_CODE]: 'errors.incorrectCountryCode',
    [OtpErrorCode.EMPTY_OR_NULL_COUNTRY_CODE]: 'errors.emptyOrNullCountryCode',
    [OtpErrorCode.BAD_REQUEST_INVALID_SIGNIN_BODY]: 'errors.badRequestInvalidSigninBody',
    [OtpErrorCode.BAD_REQUEST_INVALID_SIGNUP_MERGE_BODY]: 'errors.badRequestInvalidSignupMergeBody',
    [OtpErrorCode.BAD_REQUEST_INVALID_UPDATE_MOBILE_BODY]: 'errors.badRequestInvalidUpdateMobileBody',
    [OtpErrorCode.BAD_REQUEST_INVALID_UPDATE_EMAIL_BODY]: 'errors.badRequestInvalidUpdateEmailBody',
    [OtpErrorCode.BAD_REQUEST_INVALID_DELETE_ACCOUNT_BODY]: 'errors.badRequestInvalidDeleteAccountBody',
    [OtpErrorCode.BAD_REQUEST_INVALID_WHATSAPP_VERIFICATION_BODY]: 'errors.badRequestInvalidWhatsappVerificationBody',
    [OtpErrorCode.INVALID_OTP]: 'errors.invalidOtp',
    [OtpErrorCode.OTP_VALIDATE_LIMIT_EXCEEDED]: 'errors.otpValidateLimitExceeded',
    [OtpErrorCode.NO_SAVED_OTP_FOUND]: 'errors.noSavedOtpFound',
    [OtpErrorCode.OTP_SEND_LIMIT_EXCEEDED]: 'errors.otpSendLimitExceeded',
    [OtpErrorCode.INVALID_COOKIE_PASSED]: 'errors.invalidCookiePassed',
    [OtpErrorCode.COOKIE_NOT_FOUND]: 'errors.cookieNotFound',
    [OtpErrorCode.INVALID_AUTH_COOKIE]: 'errors.invalidAuthCookie',
    [OtpErrorCode.SESSION_VALIDATION_FAILED]: 'errors.sessionValidationFailed',
    [OtpErrorCode.USER_ALREADY_EXISTS_FOR_MOBILE]: 'errors.userAlreadyExistsForMobile',
    [OtpErrorCode.USER_ALREADY_EXISTS_FOR_EMAIL]: 'errors.userAlreadyExistsForEmail',
    [OtpErrorCode.EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE]:
        'errors.emailAccountIsAlreadyLinkedToDifferentMobile',
    [OtpErrorCode.EMAIL_ALREADY_VERIFIED]: 'errors.emailAlreadyVerified',
    [OtpErrorCode.MOBILE_ALREADY_VERIFIED]: 'errors.mobileAlreadyVerified',
    [OtpErrorCode.MOBILE_NOT_FOUND_FOR_SIGNED_IN_USER]: 'errors.mobileNotFoundForSignedInUser',
    [OtpErrorCode.EMAIL_NOT_FOUND_FOR_SIGNED_IN_USER]: 'errors.emailNotFoundForSignedInUser',
    [OtpErrorCode.ACCOUNT_MERGE_LIMIT_EXCEEDED]: 'errors.accountMergeLimitExceeded',
    [OtpErrorCode.CROSS_DOMAIN_MERGE_NOT_ALLOWED]: 'errors.crossDomainMergeNotAllowed',
    [OtpErrorCode.NOT_B2C_USER]: 'errors.notB2cUser',
    [OtpErrorCode.UPDATE_IS_PROHIBITED]: 'errors.updateIsProhibited',
    [OtpErrorCode.FEATURE_IS_CURRENTLY_DISABLED]: 'errors.featureIsCurrentlyDisabled',
    [OtpErrorCode.USER_NOT_FOUND]: 'errors.userNotFound',
    [OtpErrorCode.SIGNED_IN_USER_NOT_FOUND]: 'errors.signedInUserNotFound',
    [OtpErrorCode.EMAIL_BASED_USER_NOT_FOUND]: 'errors.emailBasedUserNotFound',
    [OtpErrorCode.LINKED_COMPANY_NOT_FOUND]: 'errors.linkedCompanyNotFound',
    [OtpErrorCode.DOMAIN_NOT_SUPPORTED]: 'errors.domainNotSupported',
    [OtpErrorCode.ERROR_IN_SENDING_SMS]: 'errors.errorInSendingSms',
    [OtpErrorCode.ERROR_IN_SENDING_EMAIL]: 'errors.errorInSendingEmail',
    [OtpErrorCode.ERROR_IN_SENDING_WHATSAPP_OTP]: 'errors.errorInSendingWhatsappOtp',
    [OtpErrorCode.SOMETHING_WENT_WRONG]: 'errors.somethingWentWrong'
}

// Legacy mapping kept for backward compatibility (UI treatment and field info only, no messages)
export const OTP_ERROR_MAPPINGS: Record<string, Omit<ErrorMapping, 'message'>> = {
    // Input Validation Errors
    [OtpErrorCode.INVALID_REQUEST]: {
        uiTreatment: UITreatment.INLINE_VALIDATION
    },
    [OtpErrorCode.INVALID_EMAIL_PATTERN]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'email'
    },
    [OtpErrorCode.INCORRECT_EMAIL]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'email'
    },
    [OtpErrorCode.INCORRECT_MOBILE]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'mobile'
    },
    [OtpErrorCode.MOBILE_TOO_LONG]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'mobile'
    },
    [OtpErrorCode.EMPTY_OR_NULL_MOBILE_NUMBER]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'mobile'
    },
    [OtpErrorCode.INCORRECT_COUNTRY_CODE]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'countryCode'
    },
    [OtpErrorCode.EMPTY_OR_NULL_COUNTRY_CODE]: {
        uiTreatment: UITreatment.HIGHLIGHT_FIELD,
        field: 'countryCode'
    },

    // Action-specific body validation
    [OtpErrorCode.BAD_REQUEST_INVALID_SIGNIN_BODY]: {
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    },
    [OtpErrorCode.BAD_REQUEST_INVALID_SIGNUP_MERGE_BODY]: {
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    },
    [OtpErrorCode.BAD_REQUEST_INVALID_UPDATE_MOBILE_BODY]: {
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    },
    [OtpErrorCode.BAD_REQUEST_INVALID_UPDATE_EMAIL_BODY]: {
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    },
    [OtpErrorCode.BAD_REQUEST_INVALID_DELETE_ACCOUNT_BODY]: {
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    },
    [OtpErrorCode.BAD_REQUEST_INVALID_WHATSAPP_VERIFICATION_BODY]: {
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    },

    // OTP Related Errors
    [OtpErrorCode.INVALID_OTP]: {
        uiTreatment: UITreatment.SHAKE_ANIMATION,
        field: 'otp'
    },
    [OtpErrorCode.OTP_VALIDATE_LIMIT_EXCEEDED]: {
        uiTreatment: UITreatment.SHOW_RESEND_BUTTON
    },
    [OtpErrorCode.NO_SAVED_OTP_FOUND]: {
        uiTreatment: UITreatment.SHOW_RESEND_BUTTON
    },
    [OtpErrorCode.OTP_SEND_LIMIT_EXCEEDED]: {
        uiTreatment: UITreatment.DISABLE_SEND_BUTTON
    },

    // Session & Cookie Errors
    [OtpErrorCode.INVALID_COOKIE_PASSED]: {
        uiTreatment: UITreatment.REFRESH_PAGE
    },
    [OtpErrorCode.COOKIE_NOT_FOUND]: {
        uiTreatment: UITreatment.REFRESH_PAGE
    },
    [OtpErrorCode.INVALID_AUTH_COOKIE]: {
        uiTreatment: UITreatment.REFRESH_PAGE
    },
    [OtpErrorCode.SESSION_VALIDATION_FAILED]: {
        uiTreatment: UITreatment.REFRESH_PAGE
    },

    // User Existence & Conflicts
    [OtpErrorCode.USER_ALREADY_EXISTS_FOR_MOBILE]: {
        uiTreatment: UITreatment.SHOW_SIGNIN_OPTION
    },
    [OtpErrorCode.USER_ALREADY_EXISTS_FOR_EMAIL]: {
        uiTreatment: UITreatment.SHOW_SIGNIN_OPTION
    },
    [OtpErrorCode.EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },

    // Verification Status
    [OtpErrorCode.EMAIL_ALREADY_VERIFIED]: {
        uiTreatment: UITreatment.SUCCESS_STATE
    },
    [OtpErrorCode.MOBILE_ALREADY_VERIFIED]: {
        uiTreatment: UITreatment.SUCCESS_STATE
    },

    // User State Errors
    [OtpErrorCode.MOBILE_NOT_FOUND_FOR_SIGNED_IN_USER]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },
    [OtpErrorCode.EMAIL_NOT_FOUND_FOR_SIGNED_IN_USER]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },

    // Business Rules
    [OtpErrorCode.ACCOUNT_MERGE_LIMIT_EXCEEDED]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },
    [OtpErrorCode.CROSS_DOMAIN_MERGE_NOT_ALLOWED]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },
    [OtpErrorCode.NOT_B2C_USER]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },
    [OtpErrorCode.UPDATE_IS_PROHIBITED]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },
    [OtpErrorCode.FEATURE_IS_CURRENTLY_DISABLED]: {
        uiTreatment: UITreatment.RETRY_OPTION
    },

    // Resource Not Found Errors
    [OtpErrorCode.USER_NOT_FOUND]: {
        uiTreatment: UITreatment.SHOW_SIGNUP_OPTION
    },
    [OtpErrorCode.SIGNED_IN_USER_NOT_FOUND]: {
        uiTreatment: UITreatment.SHOW_SIGNIN_OPTION
    },
    [OtpErrorCode.EMAIL_BASED_USER_NOT_FOUND]: {
        uiTreatment: UITreatment.SHOW_SIGNUP_OPTION
    },
    [OtpErrorCode.LINKED_COMPANY_NOT_FOUND]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },

    // Domain & Service Errors
    [OtpErrorCode.DOMAIN_NOT_SUPPORTED]: {
        uiTreatment: UITreatment.CONTACT_SUPPORT
    },

    // Server Errors
    [OtpErrorCode.ERROR_IN_SENDING_SMS]: {
        uiTreatment: UITreatment.ALTERNATIVE_OPTIONS
    },
    [OtpErrorCode.ERROR_IN_SENDING_EMAIL]: {
        uiTreatment: UITreatment.ALTERNATIVE_OPTIONS
    },
    [OtpErrorCode.ERROR_IN_SENDING_WHATSAPP_OTP]: {
        uiTreatment: UITreatment.RETRY_OPTION
    },
    [OtpErrorCode.SOMETHING_WENT_WRONG]: {
        uiTreatment: UITreatment.RETRY_OPTION
    }
}

/**
 * Maps an API error code to a user-friendly message and UI treatment
 * @param errorCode - The error code from the API
 * @param translate - Translation function (from useTranslations('otpModal'))
 * @param fallbackMessage - Optional fallback message if translation is not available
 */
export function mapOtpError(
    errorCode: string | undefined,
    translate?: (key: string) => string,
    fallbackMessage?: string
): ErrorMapping {
    // Default translation function (returns key if no translate provided)
    const t = translate || ((key: string) => key)

    if (!errorCode) {
        return {
            message: fallbackMessage || t('errors.unexpectedError'),
            uiTreatment: UITreatment.GENERAL_MODAL_ERROR
        }
    }

    // Try direct mapping first
    let mapping = OTP_ERROR_MAPPINGS[errorCode]
    let translationKey = ERROR_CODE_TO_TRANSLATION_KEY[errorCode]

    if (!mapping) {
        // Try case-insensitive match
        const upperErrorCode = errorCode.toUpperCase()
        const matchedKey = Object.keys(OTP_ERROR_MAPPINGS).find(key => key.toUpperCase() === upperErrorCode)
        if (matchedKey) {
            mapping = OTP_ERROR_MAPPINGS[matchedKey]
            translationKey = ERROR_CODE_TO_TRANSLATION_KEY[matchedKey]
        }
    }

    // Check if the error code contains known patterns
    if (!mapping) {
        if (errorCode.toLowerCase().includes('invalid') && errorCode.toLowerCase().includes('otp')) {
            mapping = OTP_ERROR_MAPPINGS[OtpErrorCode.INVALID_OTP]
            translationKey = ERROR_CODE_TO_TRANSLATION_KEY[OtpErrorCode.INVALID_OTP]
        } else if (errorCode.toLowerCase().includes('expired')) {
            mapping = OTP_ERROR_MAPPINGS[OtpErrorCode.NO_SAVED_OTP_FOUND]
            translationKey = ERROR_CODE_TO_TRANSLATION_KEY[OtpErrorCode.NO_SAVED_OTP_FOUND]
        } else if (errorCode.toLowerCase().includes('limit') && errorCode.toLowerCase().includes('exceeded')) {
            if (errorCode.toLowerCase().includes('validate')) {
                mapping = OTP_ERROR_MAPPINGS[OtpErrorCode.OTP_VALIDATE_LIMIT_EXCEEDED]
                translationKey = ERROR_CODE_TO_TRANSLATION_KEY[OtpErrorCode.OTP_VALIDATE_LIMIT_EXCEEDED]
            } else {
                mapping = OTP_ERROR_MAPPINGS[OtpErrorCode.OTP_SEND_LIMIT_EXCEEDED]
                translationKey = ERROR_CODE_TO_TRANSLATION_KEY[OtpErrorCode.OTP_SEND_LIMIT_EXCEEDED]
            }
        }
    }

    // If we found a mapping, use it with translation
    if (mapping && translationKey) {
        return {
            message: t(translationKey),
            ...mapping
        }
    }

    // Return fallback message
    return {
        message: fallbackMessage || t('errors.unexpectedError'),
        uiTreatment: UITreatment.GENERAL_MODAL_ERROR
    }
}

/**
 * Extract error code from API error response
 * Backend returns error codes in the 'message' field for HTTP errors
 */
export function extractErrorCode(error: any): string | undefined {
    return (
        error?.data?.message || // Primary: HTTP errors from backend
        error?.data?.error || // Fallback: Some endpoints might use 'error' field
        error?.data?.errorCode || // Fallback: Standard error code field
        error?.message // Last resort: Network/client errors
    )
}

/**
 * Normalize error message by cleaning up formatting
 */
export function normalizeErrorMessage(message: string): string {
    if (!message) return ''
    // Remove underscores and extra spaces
    return message.replace(/_/g, ' ').replace(/\s+/g, ' ').trim()
}
